import axios from "services/auth/jwt/config";

const reportCardResultService = {
  getAll: (reportCard, page, searchString = "", owner = "") =>
    axios.get("/reportcardresult/getall", { params: { reportCard, page, limit: 10, searchString, ...(owner ? { owner } : {}) } }),
  getById: id => axios.get(`/reportcardresult/getbyid/${id}`),
  create: data => axios.post("/reportcardresult/create", data),
  importCsv: (reportCard, file) => {
    const data = new FormData();
    data.append("csvFile", file);
    return axios.post(`/reportcardresult/import/${reportCard}`, data);
  },
  update: (id, data) => axios.patch(`/reportcardresult/update/${id}`, data),
  remove: id => axios.delete(`/reportcardresult/delete/${id}`)
};

export default reportCardResultService;
